import Vue from 'vue';
import Vuex from 'vuex';
import { Howl } from 'howler';
import music from '@/assets/sound/music.mp3';

Vue.use(Vuex);

export default new Vuex.Store({
  // state
  state: {
    fontLoaded: false,
    resourcesLoaded: false,
    soundLoaded: false,
    loaderIsOpen: true,

    heroIsCreated: false,

    menuIsOpen: false,
    footerIsOpen: false,

    mute: false,

    formStatus: null,

    // pages
    pageIndex: 0,
    pages: [
      {
        name: 'Imagine',
        path: 'imagine',
        reference: 'imagine',
        chapter: 'one',
      },
      {
        name: 'Your dream',
        path: 'your-dream',
        reference: 'yourDream',
        chapter: 'two',
      },
      {
        name: 'Come true',
        path: 'come-true',
        reference: 'comeTrue',
        chapter: 'three',
      },
    ],

    // transition & animation
    transitionDuration: 1000,
    slideInTransition: false,
    pageInTransition: false,
    blobInTransition: false,

    sound: new Howl({
      src: [music],
      loop: true,
      autoplay: false,
    }),
  },

  // getters
  getters: {
    getCurrentPage: ({ pages, pageIndex }) => pages[pageIndex],
    getPrevPage: ({ pages, pageIndex }) => {
      if (pageIndex - 1 < 0) return pages[pages.length - 1];
      return pages[pageIndex - 1];
    },
    getNextPage: ({ pages, pageIndex }) => {
      if (pageIndex + 1 >= pages.length) return pages[0];
      return pages[pageIndex + 1];
    },
    getFormStatus: state => state.formStatus,
  },

  // mutations
  mutations: {
    stopLoadingFont(state) {
      state.fontLoaded = true;
    },
    stopLoadingResources(state) {
      state.resourcesLoaded = true;
    },
    stopLoadingSound(state) {
      state.soundLoaded = true;
    },
    closeLoader(state) {
      state.loaderIsOpen = false;
    },
    heroWasCreated(state) {
      state.heroIsCreated = true;
    },

    FORM_STATUS(state, payload) {
      state.formStatus = payload;
    },
    toggleMenu(state) {
      state.menuIsOpen = !state.menuIsOpen;
    },
    closeMenu(state) {
      state.menuIsOpen = false;
    },
    toggleFooter(state) {
      state.footerIsOpen = !state.footerIsOpen;
    },

    togglePageTransition(state, bool) {
      state.pageInTransition = bool;
    },
    toggleSlideTransition(state, bool) {
      state.slideInTransition = bool;
    },
    toggleBlobTransition(state, bool) {
      state.blobInTransition = bool;
    },
    toggleMute(state) {
      state.mute = !state.mute;
    },


    // page navigation
    goPrevPage(state) {
      state.pageIndex -= 1;

      if (state.pageIndex < 0) {
        state.pageIndex = state.pages.length - 1;
      }
    },
    goNextPage(state) {
      state.pageIndex += 1;

      if (state.pageIndex >= state.pages.length) {
        state.pageIndex = 0;
      }
    },
    goAtPage(state, pageName) {
      const index = state.pages.findIndex(page => page.name === pageName);

      if (index !== -1) state.pageIndex = index;
    },
  },
});
